
/* styles */
require("!!vue-style-loader!css-loader!../../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-28c6e209&scoped=true!sass-loader!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./PageContent.vue")

var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./PageContent.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-28c6e209!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./PageContent.vue"),
  /* scopeId */
  "data-v-28c6e209",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/page/partials/Order/Catalog/PageContent.vue
// module id = 632
// module chunks = 0